// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__36Vp5","notes":"Notes_notes__2_2y4"};